import React from 'react';
import { motion } from 'framer-motion';
import CardComponent from './Cards';

const cardSpring = {
  type: "spring",
  stiffness: 110, 
  damping: 18,    
  mass: 1
};

export default function AnimatedCard({ 
  card, layoutId, className, onClick, playable, faceDown,
  index = 0, customDelay, exit, 
  targetX = 0, targetY = 0, targetRotate = 0, zIndexProp,
  startX = 0, startY = 0 // THE FIX: Added spawn coordinates
}) {
  return (
    <motion.div
      layoutId={layoutId}
      className={className}
      transition={{
        ...cardSpring,
        delay: customDelay !== undefined ? customDelay : (index * 0.08) 
      }}
      /* THE FIX: Start the card scaled down at the player's seat coordinates */
      initial={{ opacity: 0, scale: 0.5, x: startX, y: startY }} 
      animate={{ opacity: 1, scale: 1, x: targetX, y: targetY, rotate: targetRotate }}
      exit={exit} 
      onAnimationStart={() => {}}
      style={{ zIndex: zIndexProp !== undefined ? zIndexProp : 1 }}
      whileHover={playable ? { y: -20, scale: 1.05, zIndex: 100 } : {}}
      whileTap={playable ? { scale: 0.95 } : {}}
    >
      <CardComponent card={card} playable={playable} faceDown={faceDown} onClick={onClick} />
    </motion.div>
  );
}